import { registerQueryFilterLabels } from 'components/organisms/filters/query-form/labels/QueryFilterLabels';
import i18n from 'locales/i18n';

import { STATUS } from 'services/types';
import { IVideoSearch } from 'services/video/types';
import { booleanLabel } from 'utils/components/inputs/booleanLabel';

registerQueryFilterLabels<IVideoSearch>('video', {
  status: ({ value }) =>
    value !== undefined ? i18n.t(`enum.STATUS.${STATUS[value as STATUS]}`) : null,

  hasDuplicatedArtist: booleanLabel('input.label.hasDuplicatedArtist'),
  hasContracts: booleanLabel('input.label.hasContracts'),
});
